import _ from 'underscore';
import Localizer from 'localizer';
import ModalPopupView from 'views/main/Modal/ModalPopupView';
import GdprImplicitConsentModalView from 'views/gdpr/GdprImplicitConsentModalView';
import GdprModalFooterView from 'views/gdpr/GdprModalFooterView';
import UserPreference from 'models/user/UserPreference';
import NavigationUtil from 'utils/NavigationUtil';

export default {
    openGdprModal: function(displayName, requesteeId, connectionsView, callback) {
        var gdprModalView = new GdprImplicitConsentModalView({
            modalTitle: Localizer.localize('gdpr_connections_modal_title'),
            modalBody: Localizer.localize('gdpr_connections_text')
        });

        if (_.isFunction(callback)) {
            callback();
        }

        this.modalPopupView = new ModalPopupView({
            view: gdprModalView,
            modalTitle: Localizer.localize('data_and_privacy'),
            showFooter: true,
            onSaveButtonClicked: function() {
                this.confirmConnection(displayName, requesteeId, connectionsView);
            }.bind(this),
            onCloseButtonClicked: function() {
                if (_.isFunction(callback)) {
                    callback();
                }
            }.bind(this)
        });
        this.modalPopupView.render();
        var gdprFooterTemplate = new GdprModalFooterView({
            el: this.modalPopupView.$('.modal-footer'),
            cancelBtn: Localizer.localize('cancel'),
            showMiddleBtn: true,
            middleBtn: Localizer.localize('gdpr_connections_modal_btn'),
            saveBtn: Localizer.localize('ok'),
            showFooterLink: true,
            footerTextLink: Localizer.localize('gdpr_connections_modal_privacy'),
            footerLink: NavigationUtil.url('/settings/privacySettings')
        });
        gdprFooterTemplate.listenTo(
            gdprFooterTemplate,
            GdprModalFooterView.Events.DONT_SHOW_AGAIN,
            this.doNotShowAgain.bind(this, displayName, requesteeId, connectionsView)
        );
        gdprFooterTemplate.listenTo(
            gdprFooterTemplate,
            GdprModalFooterView.Events.CANCEL_MODAL,
            this.closeModal.bind(this, callback)
        );
        gdprFooterTemplate.render();
    },

    confirmConnection: function(displayName, requesteeId, connectionsView) {
        this.modalPopupView.listenTo(
            this.modalPopupView,
            ModalPopupView.Events.ModalPopupClosed,
            this.saveConfirmConnection.bind(this, displayName, requesteeId, connectionsView)
        );
        this.modalPopupView.close();
    },

    saveConfirmConnection: function(displayName, requesteeId, connectionsView) {
        if (typeof connectionsView === 'function') {
            connectionsView();
        } else {
            connectionsView.confirmConnection(requesteeId, displayName);
        }
    },

    doNotShowAgain: function(displayName, requesteeId, connectionsView) {
        this.modalPopupView.listenTo(
            this.modalPopupView,
            ModalPopupView.Events.ModalPopupClosed,
            this.saveDoNotShowAgain.bind(this, displayName, requesteeId, connectionsView)
        );
        this.modalPopupView.close();
    },

    saveDoNotShowAgain: function(displayName, requesteeId, connectionsView) {
        connectionsView.confirmConnection(requesteeId, displayName);

        var userPreference = new UserPreference({
            key: 'GDPR.ProfileActivityVisibility.Dismissed',
            value: true
        });
        userPreference.save();
    },

    closeModal: function(callback) {
        if (_.isFunction(callback)) {
            callback();
        }
    }
};
